import type { RouteObject } from "react-router-dom";
import { addSlashes, withCompanyPrefix } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { CompanyNotifications } from "@/utils/lazyLoadComponents";

// ─── Path Segments ────────────────────────────────────────────────────────────
export enum COMPANY_NOTIFICATIONS_PATH_SEGMENTS {
  ROOT = "notifications",
}

// ─── Route Definition ─────────────────────────────────────────────────────────
export const companyNotificationsRoutes: RouteObject = {
  path: COMPANY_NOTIFICATIONS_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Notifications", title: "Notifications" },
  HydrateFallback: Spinner,
  children: [{ index: true, Component: CompanyNotifications }],
};

// ─── Resolved Paths ───────────────────────────────────────────────────────────
const _ROOT = withCompanyPrefix(addSlashes(COMPANY_NOTIFICATIONS_PATH_SEGMENTS.ROOT));
const _tab = (hTab: string) => `${_ROOT}?hTab=${hTab}`;

export const COMPANY_NOTIFICATIONS_PATHS = Object.freeze({
  ROOT: _ROOT,
  TAB_ALL: _tab("ALL"),
  TAB_UNREAD: _tab("UNREAD"),
});
